import { Button } from '@frontend/design_system'
import { COMPLETE_CONFIRMATION, SUBMIT } from 'texts/common'
import { useEffect, useState } from 'react'
import { Confirmation } from 'ui/molecules/Confirmation'
import { fleetApi } from 'api'
import { useApiRequest } from 'hooks/useApiRequest'
import { useCompanyId } from 'hooks/useCompanyId'
import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { URLS } from 'constants/urls'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setNotificationMessage } from 'redux/notifications/slice'
import { setPageStatus } from 'redux/login/slice'
import { SUCCESS_PRICE_LISTS_UPDATE } from 'texts/priceLists'
import styles from './styles.module.scss'

export const SubmitButton = () => {
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false)
  const [isApproveAvailable, setIsApproveAvailable] = useState(false)

  const companyId = useCompanyId()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const priceListCompleteRequest = useApiRequest((companyId) =>
    fleetApi.priceListComplete(companyId)
  )

  const checkPriceListApproveRequest = useApiRequest((companyId) =>
    fleetApi.checkPriceListApprove(Number(companyId))
  )

  const fetchCheckPriceListApprove = async () => {
    const response = await checkPriceListApproveRequest.apiRequest(companyId)
    if (response) {
      setIsApproveAvailable(response.data.IsApproveAvailable)
    }
  }

  useEffect(() => {
    if (companyId) {
      fetchCheckPriceListApprove()
    }
  }, [companyId])

  const handleModalShow = () => {
    setConfirmationModalOpen(true)
  }

  const handleModalClose = () => {
    setConfirmationModalOpen(false)
  }

  const handleCompeteConfirm = async () => {
    if (companyId) {
      const response = await priceListCompleteRequest.apiRequest(companyId)
      if (response) {
        handleModalClose()
        dispatch(
          setNotificationMessage({
            notificationMessage: SUCCESS_PRICE_LISTS_UPDATE,
          })
        )
        dispatch(
          setPageStatus({ priceListsStatus: REGISTRATION_STATUSES.REVIEW })
        )
        navigate(`${URLS.FLEET}${URLS.PRICE_LIST}`)
      }
    }
  }

  return (
    <>
      {isConfirmationModalOpen && (
        <Confirmation
          confirmModalProps={{
            question: COMPLETE_CONFIRMATION.CONFIRMATION_MODAL.QUESTION,
            onConfirm: handleCompeteConfirm,
            onClose: handleModalClose,
            title: COMPLETE_CONFIRMATION.CONFIRMATION_MODAL.TITLE,
            confirmLabel: COMPLETE_CONFIRMATION.CONFIRMATION_MODAL.BUTTON_LABEL,
          }}
        />
      )}
      <div className={styles['complete-btn']}>
        <Button
          onClick={handleModalShow}
          label={SUBMIT}
          typographyName="Button2"
          disabled={!isApproveAvailable}
          variant="green"
        />
      </div>
    </>
  )
}
